module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei7.svg";